import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'

export const DoubleOptInLayout = observer(() => {
  return <Outlet />
})
